import React from 'react';
import { CheckCircle2, Clock, Hourglass } from 'lucide-react';
import { useReviewerSummary } from '../../../hooks/analytics/useReviewerReports.ts';
import { StatCard, WidgetCard } from '../controller/shared.tsx';

/** `reviewer_summary` — pending/reviewed counts + average wait time. */
export const ReviewerSummaryCard: React.FC = () => {
  const { data, isLoading, isError, error, dataUpdatedAt, isFetching, refetch } = useReviewerSummary();

  return (
    <WidgetCard
      title="Review Summary"
      description="Pending vs. reviewed runs, and average time waiting for review"
      loading={isLoading}
      error={isError ? error : null}
      errorMessage={error?.message ?? 'Failed to load the review summary.'}
      isEmpty={!isLoading && !isError && !data}
      updatedAt={dataUpdatedAt}
      onRefresh={refetch}
      isFetching={isFetching}
    >
      <div className="analytics-kpi-grid gap-3">
        <StatCard
          title="Pending Review"
          value={data?.pending_review ?? 0}
          icon={<Hourglass className="h-5 w-5" />}
          color="bg-amber-100 text-amber-600"
        />
        <StatCard
          title="Reviewed"
          value={data?.reviewed_count ?? 0}
          icon={<CheckCircle2 className="h-5 w-5" />}
          color="bg-emerald-100 text-emerald-600"
        />
        <StatCard
          title="Avg. Days Waiting"
          value={data?.avg_days_waiting != null ? data.avg_days_waiting.toFixed(1) : '—'}
          icon={<Clock className="h-5 w-5" />}
          color="bg-blue-100 text-blue-600"
        />
      </div>
    </WidgetCard>
  );
};

export default ReviewerSummaryCard;
